import React from 'react';

const AstroLogin = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h2>Astrology Service Login</h2>
      {/* Your login form goes here */}
      <form>
        <input type="text" placeholder="Username" required />
        <br />
        <input type="password" placeholder="Password" required />
        <br />
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default AstroLogin;
